import { ComponentPropsWithRef, forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

type TextInputProps = ComponentPropsWithRef<'input'> & {};

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(textInputVariants({ className }))} {...props} />
));
TextInput.displayName = 'TextInput';

const textInputVariants = cva([
  'text-sm',
  'leading-none',
  'outline-none',
  'text-ellipsis',
  'overflow-hidden',
  'whitespace-nowrap',
]);

export default TextInput;
